/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CreationIncidentEventDto } from './CreationIncidentEventDto';
import type { DatasetBriefDto } from './DatasetBriefDto';
import type { GetTeamLightResponseDto } from './GetTeamLightResponseDto';
import type { ImpactedAssetsSearchDto } from './ImpactedAssetsSearchDto';
import type { RuleInIncidentScopeDto } from './RuleInIncidentScopeDto';
import type { UserDto } from './UserDto';

export type GetIncidentDetailsResponseDto = {
    creationIncidentEvent?: CreationIncidentEventDto;
    datasets?: Array<DatasetBriefDto>;
    id?: string;
    impactedAssets?: ImpactedAssetsSearchDto;
    issueNo?: number;
    lastStatusModifiedDate?: number;
    monitors?: Array<RuleInIncidentScopeDto>;
    name?: string;
    owners?: Array<UserDto>;
    status?: GetIncidentDetailsResponseDto.status;
    teams?: Array<GetTeamLightResponseDto>;
};

export namespace GetIncidentDetailsResponseDto {

    export enum status {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        CLOSED = 'CLOSED',
    }


}
